// @flow
import React from 'react';
import classNames from 'classnames';
import {Link} from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles';
import styles from './AuthorAvatar.styles.js';
import Image from 'app/components/Image';

class AuthorAvatar extends React.Component<Props> {

  render() {
    const {classes, className} = this.props;
    return (
      <div className={classNames(className, classes.root)}>
        <Image
          className={{image: classes.thumbnail}}
          src={this.props.image}
          alt={this.props.name}
          border
          circle
         />
         <Link className={classes.link} to={`/author/${this.props.slug}`}>
           {this.props.name}
         </Link>
      </div>
    );
  }
}

const Component = withStyles(styles)(AuthorAvatar);
export {Component as AuthorAvatar};
export default Component;